@if (vm$ | async; as vm) {
<div class="container main-container">
  <div class="meeting-info-header">
    <img
      src="/assets/images/calendar-icon.svg"
      alt="Calendar"
      class="confirm-icon"
    />
    <p class="header-text" i18n="@@RESCHEDULE.CONFIRM_NEW_APPOINTMENT">
      Confirm new appointment
    </p>
    <p class="secondary-text-color" i18n="@@RESCHEDULE.CONFIRM_DESCRIPTION">
      Please confirm the changes to your appointment time and proceed to
      confirmation.
    </p>
  </div>
  <!-- Details Section -->
  <div class="margin-top-20">
    <div class="header-details">
      <mat-icon class="icon">person</mat-icon>
      <div class="header-title">Details</div>
    </div>
    <div class="component-body profile-backdrop" style="gap: 10px">
      <p class="details-title">{{ vm.displayTitle }}</p>
      @if (vm.hostNames) {
      <p class="details-host">with {{ vm.hostNames }}</p>
      }
    </div>
  </div>
  <!-- When Section -->
  <div class="margin-top-20">
    <div class="header-details">
      <mat-icon class="icon">today</mat-icon>
      <div class="header-title">When</div>
    </div>
    <div class="component-body calendar-backdrop">
      <!-- Old time with strikethrough -->
      @if (vm.oldTimeSlot && isTimeSlotChanged) {
      <div class="old-time">
        <p class="strikethrough">{{ vm.oldDateFormatted }}</p>
        <p class="strikethrough">
          {{
            vm.oldTimeSlot.start | date : 'h:mm a' : (timezoneOffset$ | async)
          }}
          to
          {{
            vm.oldTimeSlot.end | date : 'h:mm a' : (timezoneOffset$ | async)
          }},
          {{ vm.oldTimezoneZone }}
        </p>
      </div>
      }
      <!-- New time -->
      @if (vm.newTimeSlot && isTimeSlotChanged) {
      <div class="new-time-section">
        <span class="updated-label" i18n="@@RESCHEDULE.UPDATED_DATE_TIME"
          >Updated date & time</span
        >
        <p class="primary-text">{{ vm.newDateFormatted }}</p>
        <div class="flex-space-between">
          <span class="primary-text">
            {{
              vm.newTimeSlot.start | date : 'h:mm a' : (timezoneOffset$ | async)
            }}
            to
            {{
              vm.newTimeSlot.end | date : 'h:mm a' : (timezoneOffset$ | async)
            }},
            {{ vm.newTimezoneZone }}
          </span>
          <span class="display-duration">{{ vm.newDurationFormatted }}</span>
        </div>
      </div>
      }
      <!-- No time change - just show current -->
      @if (vm.newTimeSlot && !isTimeSlotChanged) {
      <div class="new-time-section">
        <p class="primary-text">{{ vm.newDateFormatted }}</p>
        <div class="flex-space-between">
          <span class="primary-text">
            {{
              vm.newTimeSlot.start | date : 'h:mm a' : (timezoneOffset$ | async)
            }}
            to
            {{
              vm.newTimeSlot.end | date : 'h:mm a' : (timezoneOffset$ | async)
            }},
            {{ vm.newTimezoneZone }}
          </span>
          <span class="display-duration">{{ vm.newDurationFormatted }}</span>
        </div>
      </div>
      }
    </div>
  </div>
  <!-- Where Section -->
  <div class="margin-top-20">
    <div class="header-details">
      <mat-icon class="icon">location_on</mat-icon>
      <div class="header-title">Where</div>
    </div>
    @if (vm.isBatch && vm.isInPerson) {
      @for (meeting of vm.meetings; track meeting.meetingId) {
        @if (meeting.isInPerson && meeting.location) {
        <div class="component-body location-backdrop batch-meeting-link-box">
          <p class="batch-meeting-title">{{ meeting.eventTypeName }}</p>
          <p class="location-text">{{ meeting.location }}</p>
          <div class="anchor-tag" (click)="navigateToGoogleMaps(meeting.location)">
            <img src="/assets/images/direction.svg" alt="Direction" class="direction-icon" />
            Get Directions
          </div>
        </div>
        } @else {
        <div class="component-body location-backdrop batch-meeting-link-box">
          {{ meeting.eventTypeName }} - Online appointment
        </div>
        }
      }
    } @else if (vm.isBatch && !vm.isInPerson) {
      <div class="component-body location-backdrop">
        <p class="location-text">Online appointment</p>
      </div>
    } @else {
      @if (vm.showLocation && isLocationChanged) {
      <div class="component-body location-backdrop">
        <p class="strikethrough">{{ vm.oldLocation }}</p>
        <span class="updated-label"></span>
        <p class="primary-text">{{ vm.newLocation }}</p>
        <div class="anchor-tag" (click)="navigateToGoogleMaps(vm.newLocation)">
          <img src="/assets/images/direction.svg" alt="Direction" class="direction-icon" />
          Get Directions
        </div>
      </div>
      } @else if (vm.showLocation && !isLocationChanged) {
      <div class="component-body location-backdrop">
        <p class="location-text">{{ vm.oldLocation }}</p>
        <div class="anchor-tag" (click)="navigateToGoogleMaps(vm.oldLocation)">
          <img src="/assets/images/direction.svg" alt="Direction" class="direction-icon" />
          Get Directions
        </div>
      </div>
      }
      @if (!vm.showLocation || (vm.isVideo && vm.isInPerson)) {
      <div class="component-body location-backdrop">
        <p class="location-text">Online appointment</p>
      </div>
      }
    }
  </div>
  <!-- Info Banner -->
  <div class="info-banner margin-top-20">
    <mat-icon class="info-icon">info</mat-icon>
    <span i18n="@@RESCHEDULE.MEETING_LINK_CALENDAR_UPDATED_AUTO"
      >Meeting link and calendar invite will be updated automatically.</span
    >
  </div>
  <!-- Action Buttons -->
  <div class="actions margin-top-20">
    <button
      mat-stroked-button
      class="choose-another-btn"
      (click)="onChooseAnotherTime()"
      [disabled]="isSubmitting"
      i18n="@@RESCHEDULE.CHOOSE_ANOTHER_TIME"
    >
      Choose another time
    </button>
    <button
      mat-raised-button
      color="primary"
      class="confirm-btn"
      (click)="onConfirm()"
      [disabled]="(!isLocationChanged && !isTimeSlotChanged) || isSubmitting"
      i18n="@@RESCHEDULE.CONFIRM_CHANGES"
    >
      Confirm changes
    </button>
  </div>
  <!-- Business Logo -->
  @if (vm.businessLogo) {
  <div class="margin-top-20 flex-center-align">
    <img [src]="vm.businessLogo" alt="Business Logo" class="business-logo" />
  </div>
  }
</div>
} @else {
<div class="loading-container">
  <div class="loading-spinner"></div>
</div>
}
